import React, { useState, useEffect, useContext } from 'react';
import { string, bool, shape } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { Carousel } from '@thd-olt-component-react/carousel';

import { makeApiRequest } from './request';
import {
  getSchema, isServer, getSkus, getDefaultBanner, shouldMakeApiRequest
} from './helpers';

const SponsoredSkyscraperBanner = (props) => {
  const [lastRequestScenario, setLastRequestScenario] = useState({});
  const [hasData, setHasData] = useState(false);
  const { renderTallBanner = false } = useLayoutGroupProps({ props });
  const experienceContext = useContext(ExperienceContext);
  const { pageContext } = props;
  let { schema } = props;

  schema = getSchema({ schema, pageContext });
  const schemaId = schema + '__skyscraper';

  useEffect(() => {
    if (renderTallBanner) {
      const isValidScenario = shouldMakeApiRequest({ lastRequestScenario, experienceContext, pageContext });

      if (isValidScenario) {
        setLastRequestScenario({
          url: window.location.pathname + window.location.search,
          skus: getSkus(pageContext)
        });

        makeApiRequest({
          schema, schemaId, experienceContext, pageContext, setHasData, bannerType: 'skyscraper'
        });
      }
    }
  }, [pageContext.data]);

  if (!renderTallBanner) {
    return null;
  }

  return (
    <div style={{ width: '160px', maxWidth: '100%', margin: '0 auto' }}>
      <div id={schemaId} />
    </div>
  );
};

SponsoredSkyscraperBanner.propTypes = {
  schema: string,
  pageContext: shape({
    label: string,
    data: shape(),
    keyword: string,
    isSearch: bool,
    isCategory: bool,
    isBrowse: bool
  }),
};

SponsoredSkyscraperBanner.defaultProps = {
  schema: '',
  pageContext: {},
};

export { SponsoredSkyscraperBanner };
